//src/api/categoryApi.js

import axiosInstance from './axiosInstance'; 

export const fetchCategories = async () => {
  const response = await axiosInstance.get('/categories/');
  return response.data;
};


export const createCategory = async (categoryData) => {
  const response = await axiosInstance.post('/categories/', categoryData);
  return response.data;
};

